import React from 'react';
import { Button, Modal } from 'antd';
import cx from 'classnames';
import { FieldArrayRenderProps, FormikProps } from 'formik';

import { BillingInfoFormValues } from '../BillingInfo';
import {
  isAddButtonVisible,
  isRemoveButtonVisible,
} from 'utils/fieldArrayUtils';
import BillingInfoSection from '../BillingContactSection';
import { BillingContactModel } from 'api/backofficeApiClient';

import styles from './../BillingInfo.module.less';

const MAX_BILLING_INFO_SECTION = 5;

type Props = FieldArrayRenderProps;

const defaultValue: BillingContactModel = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
};

export default function BillingContactSectionArray(props: Props) {
  const { form } = props;
  const { billingContacts } = (form as FormikProps<BillingInfoFormValues>)
    .values;

  const handleAddSection = () => {
    Modal.confirm({
      width: 500,
      title: <b>IMPORTANT</b>,
      content: (
        <span>
          Contacts listed in this form will receive <b>ALL</b> billing-related
          communications for all assignments created under this customer record.
        </span>
      ),
      okText: 'Confirm',
      cancelText: 'Back',
      icon: <span className="icon icon-attention-filled" />,
      onOk() {
        props.push(defaultValue);
      },
      onCancel() {},
    });
  };

  return (
    <>
      {billingContacts.length > 0 &&
        billingContacts.map(
          (billingContact: BillingContactModel, index: number) => {
            return (
              <div key={index}>
                <BillingInfoSection
                  index={index}
                  formNamePrefix={props.name}
                  actionButtons={
                    <>
                      {isAddButtonVisible<BillingContactModel>(
                        billingContacts,
                        index,
                        MAX_BILLING_INFO_SECTION,
                      ) && (
                        <Button
                          className={cx('borderless-btn', styles.btn)}
                          onClick={handleAddSection}
                          icon={<span className="icon icon-plus-filled" />}
                        />
                      )}

                      {isRemoveButtonVisible<BillingContactModel>(
                        billingContacts,
                      ) && (
                        <Button
                          className={cx('borderless-btn', styles.btn)}
                          onClick={() => props.remove(index)}
                          icon={<span className="icon icon-closed-filled" />}
                        />
                      )}
                    </>
                  }
                />
              </div>
            );
          },
        )}
    </>
  );
}
